export default (HttpClient) => ({
  register: async ({ name, email, password }) => {
    const response = await HttpClient.post('/auth/register', {
      name,
      email,
      password
    })
    let errors = null

    if (!response.data) {
      errors = {
        status: response.request.status,
        statusText: response.request.statusText
      }
    }

    return {
      data: response.data,
      errors
    }
  },

  login: async ({ email, password }) => {
    const response = await HttpClient.post("/auth/login", {
      email,
      password,
    });

    let erros = null;

    if (!response.data) {
      erros = {
        status: response.request.status,
        statusText: response.request.statusText,
      };
    }

    return {
      data: response.data,
      erros
    };
  },
});
